// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__uWxFH","modal__header":"modal_modal__header__GCh8H","modal__close-btn":"modal_modal__close-btn__NIZ27"};